import { AppModule as IAppModule } from '../../interfaces/appmodule';
import { IconLoader, IIcon } from '@loaders/IconLoader';
import { SpaConfiguration } from './SpaConfiguration';
import { LocalizeLabel } from '@localization/helpers';
import { metadataRetrieveMultiple } from '@definitions/MetadataApi';

export class AppModule {
    private static _currentAppModule: AppModule;
    private static _allAppModules: Promise<AppModule[]>;

    private _iconName?: string;
    public name: string;
    public description: string;
    public uniquename: string;
    public appmoduleid: string;
    public ismanaged: boolean;
    public icon?: IIcon;
    public descriptor: string;

    private constructor(appModule: IAppModule) {
        this.name = LocalizeLabel(appModule.__labels["name"]) ?? appModule.name;
        this.uniquename = appModule.uniquename;
        this.appmoduleid = appModule.appmoduleid;
        this.description = LocalizeLabel(appModule.__labels["description"]) ?? appModule.description;
        this.descriptor = appModule.descriptor;
        this.ismanaged = appModule.ismanaged;
        if (appModule.descriptor) {
            //IconLoader currently expects only this type of icon reference
            this._iconName = `/WebResource/${JSON.parse(appModule.descriptor).webResourceInfo.Name}`;
        }
    }
    static async getAllAppModules(): Promise<AppModule[]> {
        //TODO: permissions
        if (!this._allAppModules) {
            this._allAppModules = new Promise(async (resolve) => {
                const appModules: AppModule[] = [];
                const response = await metadataRetrieveMultiple('v9.1/appmodules?$select=appmoduleid, name,uniquename,descriptor,description,ismanaged');
                for (const entity of response.entities) {
                    const appModule = new AppModule(entity as IAppModule);
                    appModules.push(appModule);
                }
                resolve(appModules);
            });
        }
        return this._allAppModules;
    };
    static get(): AppModule {
        return this._currentAppModule;
    }
    static async loadAsync(name?: string): Promise<boolean> {
        if (!name) {
            //try to get app module from URL
            name = window.location.pathname.split('/')[1];
        }
        let appModule = await this._getAppModuleAsync(name);
        //if app module was not found, try to get it from configuration or local storage
        if (!appModule) {
            name = localStorage.getItem('appModuleName');
            if (!name) {
                name = SpaConfiguration.get().defaultAppModule;
            }
            //if the name was not found in the configuration or local storage, return false to tell the app provider to show app switcher
            if (!name) {
                return false;
            }
            appModule = await this._getAppModuleAsync(name);
            if (!appModule) {
                throw new Error(`App module ${name} could not be loaded!`);
            }
        }
        this._currentAppModule = new AppModule(appModule);
        return true;
    }
    public async loadIcon(): Promise<void> {
        this.icon = await IconLoader.getAsync(this._iconName);
    }
    private static async _getAppModuleAsync(name?: string): Promise<IAppModule> {
        if (!name) {
            return undefined;
        }
        const response = await metadataRetrieveMultiple(`v9.1/appmodules?$filter=uniquename eq '${name}'&$select=name,appmoduleid,uniquename,descriptor,ismanaged`);
        if (response.entities.length === 0) {
            console.log(`App module ${name} was not found!`);
            return undefined;
        }
        const appModule: IAppModule = response.entities[0] as IAppModule;
        return appModule;
    }
}